/**
 * Flag codes — client mirror of src/api/lib/flags.ts.
 * @file src/web/shared/flags.ts
 *
 * @llm-rule WHEN: Rendering a flag anywhere
 * @llm-rule NOTE: Every flag is raised by the engine, never typed. The labels
 *   here are the only user-facing wording for each rule.
 */

export type FlagCode =
  | 'LATE_CLOCK_IN'
  | 'MISSED_CLOCK_IN'
  | 'MISSED_CLOCK_OUT'
  | 'OFF_SITE_CLOCK_IN'
  | 'OFF_SITE_CLOCK_OUT'
  | 'TASK_OVERDUE';

export const FLAG_LABEL: Record<FlagCode, string> = {
  LATE_CLOCK_IN: 'Late clock-in',
  MISSED_CLOCK_IN: 'No clock-in',
  MISSED_CLOCK_OUT: 'No clock-out',
  OFF_SITE_CLOCK_IN: 'Clocked in off-site',
  OFF_SITE_CLOCK_OUT: 'Clocked out off-site',
  TASK_OVERDUE: 'Missed deadline — work not done',
};

/** One-line explanation of the rule behind each flag. */
export const FLAG_RULE: Record<FlagCode, string> = {
  LATE_CLOCK_IN: 'Clocked in after the company start time.',
  MISSED_CLOCK_IN: 'No clock-in on a working day.',
  MISSED_CLOCK_OUT: 'Clocked in but never clocked out.',
  OFF_SITE_CLOCK_IN: 'Clocked in from outside the office location.',
  OFF_SITE_CLOCK_OUT: 'Clocked out from outside the office location.',
  TASK_OVERDUE: 'The deadline passed and the work was still not done.',
};

/**
 * Compact wording for the count chips in the monthly report.
 *
 * Separate from FLAG_LABEL on purpose: the report used to shorten labels by
 * stripping the leading "Clocked ", which turned "Clocked in off-site" into the
 * meaningless "in off-site". Short forms are written, not derived.
 */
export const FLAG_SHORT: Record<FlagCode, string> = {
  LATE_CLOCK_IN: 'Late in',
  MISSED_CLOCK_IN: 'No clock-in',
  MISSED_CLOCK_OUT: 'No clock-out',
  OFF_SITE_CLOCK_IN: 'Off-site in',
  OFF_SITE_CLOCK_OUT: 'Off-site out',
  TASK_OVERDUE: 'Missed deadline',
};
